import React from 'react';
import { motion } from 'framer-motion';
import useIntersectionObserver from '../../hooks/useIntersectionObserver/useIntersectionObserver';

// images

// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const TextImage = ({
  title,
  titleTag: TitleTag = "h2",
  text,
  paragraphs,
  link,
  src
}) => {
  const [ref, isIntersecting] = useIntersectionObserver();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3 // Aggiunto per l'animazione a cascata
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };

  const titleVariants = {
    hidden: { clipPath: 'inset(0 0 100% 0)' },
    visible: {
      clipPath: 'inset(0 0 0 0)',
      transition: {
        duration: 0.8,
        ease: "easeOut",
        delay: 0.15
      }
    }
  };

  return (
    <div className={cn("wrapper")} id="chi-siamo" >
      <div className={cn("container")}>
        {src && <div className={cn("image")}>
          <img src={src} alt={title} loading="lazy" decoding="async" />
        </div>}
        <motion.div
          className={cn("content")}
          variants={containerVariants}
          initial="hidden"
          animate={isIntersecting ? "visible" : "hidden"}
          ref={ref}
        >
          <motion.div className={cn("title")} variants={titleVariants}>
            <TitleTag>{title}</TitleTag>
          </motion.div>
          <motion.div className={cn("text")} variants={itemVariants}>
            <p>{text}</p>
          </motion.div>
          {paragraphs && paragraphs.length > 0 && (
            <motion.div className={cn("paragraphs")} variants={containerVariants}>
              {paragraphs.map((paragraph, index) => (
                <motion.p key={index} className={cn("paragraph")} variants={itemVariants}>
                  {paragraph.text}
                </motion.p>
              ))}
            </motion.div>
          )}
          {link &&
            <motion.div
              className={cn("link")}
              variants={itemVariants}
              onClick={() => window.open(link, "_self")}
            >
              <a href={link}><span>Scopri di più</span></a>
            </motion.div>}
        </motion.div>
      </div>
    </div>
  );
};

export default TextImage;